<template>

  <div>
    <span v-if="exercisesForProgress.length==0">{{$t('pages.subgroups.emptyExercises')}}</span>
    <ul class="list-group">
      <li v-for="exer in exercisesForProgress" :key="exer.id" class="list-group-item">
        <div class="row my-margin">
          <div class="pull-left">
            <a href="#" @click.prevent="toggleExercisePreview(exer.exerciseId)" style="color: #d2d6de">{{exer.exercise.identifier}}</a>
          </div>
        </div>
      </li>
      <li class="margin" style="height: 30px">
        <div class="col-xs-12">
          <div class="pull-right box-tools">
              <button type="button" class="btn btn-box-tool" @click.prevent="closeDropdown()"><i class="fa fa-caret-up"></i></button>
          </div>
        </div>
      </li>
    </ul>
  </div>


</template>

<script>
import draggable from 'vuedraggable'
import Rest from './../../../services/rest'
import Exercise from '@/components/exercises/Exercise.vue'
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      CelotnaNaloga: state => state.exerciseForModal,
      selectedExercises: state => state.exercises.selectedExercises,
      exercisesForProgress: state => state.exercisesForOrder
    })
  },
  data () {
    return {
      // exercisesForProgress: []
    }
  },
  props: {
    podgrupa: Object
  },
  created () {
    /*
    this.$store.dispatch('exercisesForProgressGet', {
      pid: this.podgrupa.id,
      showVisible: true
    })
    */
    this.$store.dispatch('exercisesForOrderGet', {
      gid: this.$route.params.gid,
      yid: this.$route.params.yid,
      pid: this.podgrupa.id
    })
    // this.exercisesForProgressGet()
  },
  methods: {
    refreshExercises () {
      this.$store.dispatch('exercisesForOrderGet', {
        gid: this.$route.params.gid,
        yid: this.$route.params.yid,
        pid: this.podgrupa.id
      })
    },
    addExercises () {
      this.$store.commit('addExercisesToSubgroup', this.podgrupa.id)
      window.jQuery('#modal-exercises-add').modal('toggle')
    },
    toggleExercisePreview (id) {
      // alert(id)
      window.jQuery('#modal-show-exercise').modal('toggle')
      this.$store.dispatch('updateModalForExercise', id).then((el) => {
        // this.$nextTick(function () {
        //   window.MathJax.Hub.Queue(['Typeset', window.MathJax.Hub])
        // })
        // window.jQuery('#mo').modal('toggle')
        // window.jQuery('.modal-backdrop').remove()
      })
    },
    deleteExercise (exerId, subgroupId) {
      this.$store.dispatch('eraseExerciseFromSubgroup', {
        subgroupId: subgroupId,
        exerciseIds: exerId
      }).then(() => {
        this.exercisesForProgress.splice(this.exercisesForProgress.map(item => item.exerciseId).indexOf(exerId), 1)
      }).catch((err) => {
        alert(err.responseJSON.message)
      })
    },
    changeVisibility (exer) {
      let putData = {
        visible: !exer.visible
      }
      return Rest.request('PUT', '/subgroups/exercises/' + exer.id, putData).then((data) => { // TODO: should be false in production
        exer.visible = !exer.visible
      }).catch((err) => {
        console.log(err)
      })
    },
    exercisesForProgressGet () {
      return Rest.request('GET', `/groups/${this.$route.params.gid}/years/${this.$route.params.yid}/subgroups/${this.podgrupa.id}`).then((data) => { // TODO: should be false in production
        this.exercisesForProgress = data.subgroupExercises
      }).catch((err) => {
        console.log(err)
      })
    },
    closeDropdown () {
      this.$set(this.podgrupa, 'showPreview', !this.podgrupa.showPreview)
    }
  },
  watch: {
    exercisesForProgress (val) {
      let putData = {
        subgroupId: this.podgrupa.id,
        // orders: contex.getters.getNewOrderOfExercises
        orders: val.map(exer => exer.id)
      }
      return Rest.request('PUT', '/subgroups/exercises/order/' + this.podgrupa.id, putData).then((data) => {
      }).catch((err) => {
        console.log(err)
      })
    }
  },
  components: {
    draggable,
    'exercise': Exercise
  }
}
</script>

<style scoped>
.tekst {
color: black;
}
.btn-block {
  display:block;
  float:left;
  background-color: #008d4c ;
}
.btn-block:hover {
  background-color: #008044 ;
}
.btn-block:focus {
  background-color: #008044;
  border-color: #255625;
}
.my-margin {
  margin-left: 0.5em;
  margin-right: 0.5em;
}
.list-group-item:hover {
  cursor: default;
  background-color: lightgrey;
}
.badge {
  cursor: pointer;
}
.fa-caret-up {
  color: white
}
</style>



// WEBPACK FOOTER //
// ExercisesPreview.vue?464e541a